module.exports = __webpack_public_path__ + "static/individuals-f49ad6d624c5409f3f3bd1f920cbe31d.svg";